import script from "./guidage.vue?vue&type=script&setup=true&lang=js"
export * from "./guidage.vue?vue&type=script&setup=true&lang=js"

import "./guidage.vue?vue&type=style&index=0&id=5834ef7a&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5834ef7a"]])

export default __exports__